<template>
    <div class="root" v-if="serial && pairingcode">
        <div class="qrcodeholder" v-if="!pairingdone">
            <qr-code :text="PairingLink" :size="200" bg-color="transparent" color="#fff"></qr-code>
        </div>
        <div class="pairingholder">
            <div class="holder" v-if="!pairingdone">
                <h1>{{ translation["STR_WELCOME_TO_POC"] }}</h1>
                <span v-html="translation['STR_WELCOME_TO_POC1']"></span> {{ translation["STR_WELCOME_TO_POC2"] }}<br/><br/>
                <div class="serial">
                    {{ pairingcode }}
                </div><br/>
                {{ translation["STR_WELCOME_TO_POC3"] }}<br/><br/>
                <div v-html="translation['STR_WELCOME_TO_POC4'].replace('**supportDetail**', supportDetail)"></div>
            </div>
            <div v-else>
                <h1>Device is rebooting, please wait.</h1>
            </div>
        </div>      
    </div>
</template>
<style scoped>
.root {
    height: 100vh;
    display: flex;
    background-color: black;
}
.qrcodeholder {
    display: flex;
    width: 600px;
    height: 795px;
    justify-content: center;
    align-items: center;
    vertical-align: center;
}
.langsel {
    margin-top: 20px;
    width: 100%;
    text-align: left;
    padding-left: 48px;
}
.pairingholder {
    height: 795px;
    width: 100%;
    display: flex;
    padding-left: 55px;
    justify-content: center;
    align-items: center;
    vertical-align: center;    
    text-align: left;
    padding-right: 30px;
    flex-direction: column;
}
h1 {
    color: #fff;
    font-weight: 100;
}
.holder {
    width: 700px;
    height: 400px;
    color: #fff;
}
.supportid {
    letter-spacing: 10px;
}
.serial {
    color: #fff;
    padding: 15px;
    font-weight: bold;
    width: 400px;
    margin: auto;
    text-align: center;
    font-size: 20pt;
    letter-spacing: 10px;
    font-weight: 100;
    border: 1px solid #fff;
    box-shadow: 3px 3px 3px #fff;
}

</style>
<script>
export default ({
    props: [ 'serial', 'token', 'tvid', 'customername', 'supportDetail', 'translation', 'transl' ],
    data() {
        return {
            pairingcode: null,
            pairingdone: false,
             year: null,
        }
    },
    mounted() {
        this.year = new Date().getFullYear();
        if(this.customername) {
            top.location.href="/";
        }
        if(!this.serial) {
            this.$emit("triggererror", "Can't get Serial. Please contact support.");
        }
        this.pingPairingServer();
                setInterval(() => {
                    this.pairingCheck();
                }, 3000)        
    },
    computed: {
        PairingLink() {
            return "https://pcradmin.procomcure.com/code/"+this.pairingcode;
        }
    },
    methods: {
        SetLanguage(code) {
            this.$emit("setLang", code.lang_name)
        },
        pairingCheck() {
            this.axios.get("/api/pairing/check?code="+this.pairingcode)
            .then((r) => {
                var token = r.data.token;
                localStorage.setItem("token", token);
                this.pairingdone = true;
                this.axios.get("http://127.0.0.1:8441/procomcure?cmd=provisioning&token="+token)
                .then(() => {
                })
            });
        },
        pingPairingServer() {
            this.axios.post("/api/pairing/new?tvid="+this.tvid+"&serial="+this.serial+"&token="+this.token)
            .then((r) => {
                if(r.data.success) {
                    this.pairingcode = r.data.code;
                } else {
                    this.$emit('triggererror', 'Pairing not possible, please contact support.')
                }
            })
        }
    }
})
</script>
